import { Controller } from "@hotwired/stimulus"

// Opens a custom <dialog>-based confirmation when the user clicks the trash
// icon on an expense row. Confirming clicks a hidden Turbo-powered DELETE link
// to perform the actual destroy. Mirrors the per-entity delete-modal pattern
// used elsewhere (custom_report_type, employee, account, ...).
export default class extends Controller {
  static targets = ["dialog", "link"]

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  confirm() {
    this.close()
    this.linkTarget.click()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
